// FUNCTIONS

export const get_filters_list = () => {
    return filterList;
}

export const get_filter_from_id = (filter_id) => {
    var group_keys = Object.keys(filterList);
    var found = false;
    var filter_data = null;
    for (var i = 0; i < group_keys.length; i++) {
        if (found) { break }
        for (var j = 0; j < filterList[group_keys[i]].items.length; j++) {
            if (filterList[group_keys[i]].items[j]?.id === filter_id) {
                filter_data = filterList[group_keys[i]].items[j];
                filter_data.group_id = group_keys;
                filter_data.group_label = filterList[group_keys[i]].label;
                filter_data.position = [i, j];
                found = true;
                break;
            }
        }
    }
    return filter_data;
}



// DATA

const filterList = {
    land_geometry: {
        label: "Géométrie de la parcelle",
        items: [
            {
                id: "land_area",
                label: "Surperficie de la parcelle",
                description: "Ce critère permet de filtrer les parcelles dont la superficie est comprise entre une valeur minimum et une valeur maximum.",
                default_values: {
                    min: null,
                    max: null,
                }
            },
            {
                id: "land_perimeter",
                label: "Périmètre de la parcelle",
                description: "Ce critère permet de filtrer les parcelles dont le périmètre est compris entre une valeur minimum et une valeur maximum.",
                default_values: {
                    min: null,
                    max: null,
                }
            },
            {
                id: "land_compacity",
                label: "Compacité de la parcelle",
                description: "Ce critère permet de filtrer les parcelles dont l'indice de compacité est compris entre une valeur minimum et une valeur maximum.",
                default_values: {
                    min: null,
                    max: null,
                }
            },
        ],
    },
    buildings: {
        label: "Constructions",
        items: [
            {
                id: "built_ground_area",
                label: "Emprise bâtie",
                description: "Ce critère permet de filtrer les parcelles dont l'emprise bâtie est comprise entre une valeur minimum et une valeur maximum.",
                default_values: {
                    no_build: true,
                    min: null,
                    max: null,
                }
            },
        ],
    },
}